import DashBigNumbers from "./tabs/DashBigNumbers.vue";
import DashPsychologists from "./tabs/DashPsychologists.vue";
import DashPatients from "./tabs/DashPatients.vue";
import DashAppointments from "./tabs/DashAppointments.vue";
import DashFinancial from "./tabs/DashFinancial.vue";

export default {
  name: "Home",
  components: {
    DashBigNumbers,
    DashPsychologists,
    DashPatients,
    DashAppointments,
    DashFinancial,
  },
  mounted() {
    this.loadBigNumbers();
  },
  data() {
    return {
      activeTab: "big",
      tabs: [
        { id: "big", label: "Visão Geral", icon: "fa-solid fa-gauge-high" },
        { id: "psychologists", label: "Psicólogos", icon: "fa-solid fa-user-doctor" },
        { id: "patients", label: "Pacientes", icon: "fa-solid fa-user-group" },
        { id: "appointments", label: "Consultas", icon: "far fa-calendar-check" },
        { id: "financial", label: "Financeiro", icon: "fa-solid fa-dollar-sign" },
      ],
      // As 5 abas com filtro se auto-buscam (ver Dash*.vue); só precisam ser
      // montadas uma vez, na primeira vez que a aba é aberta.
      mountedTabs: {},
      // Big Numbers não tem filtro — busca uma vez só, como antes.
      bigLoading: false,
      bigErrored: false,
      bigData: null,
    };
  },
  methods: {
    selectTab(id) {
      this.activeTab = id;
      if (!this.mountedTabs[id]) this.$set(this.mountedTabs, id, true);
    },
    async loadBigNumbers() {
      this.bigLoading = true;
      this.bigErrored = false;
      try {
        const res = await this.$dashboardService.bigNumbers();
        this.bigData = res.data || {};
      } catch (e) {
        console.error("Erro ao carregar dashboard: big", e);
        this.bigErrored = true;
      } finally {
        this.bigLoading = false;
      }
    },
  },
};
